import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';

@Component({
  selector: 'app-student-test-report-print',
  templateUrl: './student-test-report-print.component.html',
  styleUrls: ['./student-test-report-print.component.css']
})
export class StudentTestReportPrintComponent implements OnInit {

  BranchDetails: any;
  PrintModel = {
    WSTestID: "0",
    WorkSheetID:"0"
  }
  DisplayModel = {
    ClassName: '',
    GRNo: '',
    FirstName: '',
    WorkSheetTitle:'',
    WorkSheetType:'',
    CourseName:'',
    QuestionCount:0,
    Maxmarks:0,
    AttemptCount:'',
    CorrectCount:'',
    InCorrectCount:'',
    TestScore:'',
  } 
  TestQuestionList: any;
  Integer: any;
  decimal: any;
  itemsPerPage = 10;
  pagedItems = [];

  constructor(private activatedRoute: ActivatedRoute, private learningService: LearningService,
    private spinnerService: Ng4LoadingSpinnerService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.PrintModel.WSTestID = params['WSTestID'];
      this.PrintModel.WorkSheetID = params['WorkSheetID'];
      this.GetAllTestQuestions();
    });

  }
  GetAllTestQuestions() {
    this.spinnerService.show()
    this.learningService.GetAllTestQuestions(JSON.stringify(this.PrintModel)).subscribe((response) => {
      this.BranchDetails = response.BranchDetails;      
      this.spinnerService.hide()
      this.TestQuestionList = response.TestQuestionList;  
    
      if(this.TestQuestionList!=null && this.TestQuestionList.length>0){
        this.DisplayModel.WorkSheetTitle= this.TestQuestionList[0].WorkSheetTitle;
        this.DisplayModel.WorkSheetType= this.TestQuestionList[0].WorkSheetType;
        this.DisplayModel.ClassName= this.TestQuestionList[0].ClassName;
        this.DisplayModel.CourseName= this.TestQuestionList[0].CourseName;
        this.DisplayModel.QuestionCount= this.TestQuestionList[0].QuestionCount;
        this.DisplayModel.Maxmarks= this.TestQuestionList[0].Maxmarks;
        this.DisplayModel.FirstName= this.TestQuestionList[0].FirstName;
        this.DisplayModel.GRNo= this.TestQuestionList[0].GRNo;
      var AttemptCount=0;
      var CorrectCount=0;
      var InCorrectCount=0;
      var TestScore=0;
      for(var i=0;i<this.TestQuestionList.length;i++){
        if(this.TestQuestionList[i].QStatus=='A'){
          AttemptCount=AttemptCount+1;
        }
        if(this.TestQuestionList[i].QuestionTypeID==1 && ((this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1)||(this.TestQuestionList[i].ROP2 && this.TestQuestionList[i].AROP2 ))){
          CorrectCount=CorrectCount+1;
          TestScore=TestScore+this.TestQuestionList[i].QValue;
        }
        if((this.TestQuestionList[i].QuestionTypeID==3)  && ((this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1)||(this.TestQuestionList[i].ROP2 && this.TestQuestionList[i].AROP2)||(this.TestQuestionList[i].ROP3 && this.TestQuestionList[i].AROP3)||(this.TestQuestionList[i].ROP4 && this.TestQuestionList[i].AROP4 ))){
          CorrectCount=CorrectCount+1;
          TestScore=TestScore+this.TestQuestionList[i].QValue;
        }
        if((this.TestQuestionList[i].QuestionTypeID==2)  && ( (this.TestQuestionList[i].Options==1 && this.TestQuestionList[i].ROP1 && this.TestQuestionList[i].AROP1) || (this.TestQuestionList[i].Options==2 && ((this.TestQuestionList[i].ROP2==this.TestQuestionList[i].AROP2) &&(this.TestQuestionList[i].ROP1==this.TestQuestionList[i].AROP1)))||(this.TestQuestionList[i].Options==3 && ((this.TestQuestionList[i].ROP3==this.TestQuestionList[i].AROP3) && (this.TestQuestionList[i].ROP2 == this.TestQuestionList[i].AROP2) && (this.TestQuestionList[i].ROP1 == this.TestQuestionList[i].AROP1)))||(this.TestQuestionList[i].Options==4 && ((this.TestQuestionList[i].ROP4 == this.TestQuestionList[i].AROP4 ) && (this.TestQuestionList[i].ROP3 == this.TestQuestionList[i].AROP3 )&& (this.TestQuestionList[i].ROP2 == this.TestQuestionList[i].AROP2 ) && (this.TestQuestionList[i].ROP1== this.TestQuestionList[i].AROP1))))){
          CorrectCount=CorrectCount+1;
          TestScore=TestScore+this.TestQuestionList[i].QValue;
        }
        if((this.TestQuestionList[i].QuestionTypeID==4)  && ((this.TestQuestionList[i].Options==1 && this.TestQuestionList[i].RFOP1== this.TestQuestionList[i].ARFOP1)||(this.TestQuestionList[i].Options==2 && this.TestQuestionList[i].RFOP2==this.TestQuestionList[i].ARFOP2 && this.TestQuestionList[i].RFOP1==this.TestQuestionList[i].ARFOP1)||(this.TestQuestionList[i].Options==3 && this.TestQuestionList[i].RFOP3==this.TestQuestionList[i].ARFOP3)||(this.TestQuestionList[i].Options==4 && this.TestQuestionList[i].RFOP4==this.TestQuestionList[i].ARFOP4 && this.TestQuestionList[i].RFOP3==this.TestQuestionList[i].ARFOP3 && this.TestQuestionList[i].RFOP2==this.TestQuestionList[i].ARFOP2 && this.TestQuestionList[i].RFOP1==this.TestQuestionList[i].ARFOP1) )){
          CorrectCount=CorrectCount+1;
          TestScore=TestScore+this.TestQuestionList[i].QValue;
        }
        
      }
      InCorrectCount=this.TestQuestionList.length-CorrectCount;
      this.DisplayModel.AttemptCount=AttemptCount.toString();
      this.DisplayModel.CorrectCount=CorrectCount.toString();
      this.DisplayModel.InCorrectCount=InCorrectCount.toString();
      this.DisplayModel.TestScore=TestScore.toString();
    }
        this.spinnerService.hide()
        setTimeout(function () {
          window.print();
        }, 300);
      


    });
  };


  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }

  ngOnInit() {
  }

}

